<script setup lang="ts">
interface IProps {
  text: string
}

const props = defineProps<IProps>()


const preText = computed(() => {
  return props.text.slice(0, -6)
})

const lastText = computed(() => {
  return props.text.slice(-6)
})
</script>

<template>
  <div class="flex items-center overflow-hidden leading-none text-primary">
    <div class="truncate">
      {{ preText }}
    </div>
    <div>{{ lastText }}</div>
  </div>
</template>

<style scoped lang="scss">
</style>